import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Login from "@/pages/Login";
import EmployeeDashboard from "@/pages/EmployeeDashboard";
import WebinarWatch from "@/pages/WebinarWatch";
import Profile from "@/pages/Profile";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminEmployees from "@/pages/admin/AdminEmployees";
import AdminWebinars from "@/pages/admin/AdminWebinars";
import AdminWebinarForm from "@/pages/admin/AdminWebinarForm";
import AdminQAMonitor from "@/pages/admin/AdminQAMonitor";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            theme="light"
            position="top-right"
            toastOptions={{ style: { background: "#ffffff", border: "1px solid #e4e4e7", color: "#0a0a0a", borderRadius: "2px" } }}
          />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<ProtectedRoute role="employee"><EmployeeDashboard /></ProtectedRoute>} />
            <Route path="/webinars/:id" element={<ProtectedRoute role="employee"><WebinarWatch /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute role="employee"><Profile /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/employees" element={<ProtectedRoute role="admin"><AdminEmployees /></ProtectedRoute>} />
            <Route path="/admin/webinars" element={<ProtectedRoute role="admin"><AdminWebinars /></ProtectedRoute>} />
            <Route path="/admin/webinars/new" element={<ProtectedRoute role="admin"><AdminWebinarForm /></ProtectedRoute>} />
            <Route path="/admin/webinars/:id/edit" element={<ProtectedRoute role="admin"><AdminWebinarForm /></ProtectedRoute>} />
            <Route path="/admin/webinars/:id/qa" element={<ProtectedRoute role="admin"><AdminQAMonitor /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
